import { twMerge } from "tailwind-merge";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  label?: string;
  floatingLabel?: boolean;
  height?: 32 | 36 | 40;
}

const labelStyles = {
  "32": "peer-focus:-translate-y-2 -translate-y-2 top-1.5",
  "36": "peer-focus:-translate-y-2 -translate-y-2 top-1.5",
  "40": "peer-focus:-translate-y-2.5 -translate-y-2.5 top-2.5",
};

export function InputFloatingLabel({
  label,
  wrapperClassName,
  className,
  floatingLabel = true,
  height = 32,
  ...inputProps
}: InputProps) {
  return (
    <div className={twMerge("relative w-full", wrapperClassName)}>
      <input
        style={{ height }}
        type="text"
        id="floating_filled"
        className={twMerge(
          "block rounded-md placeholder:text-transparent focus:placeholder:text-gray-400 px-2.5 pb-2.5 pt-5 w-full text-base md:text-sm bg-white dark:bg-[var(--gray-a1)] border border-[var(--gray-7)] appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer",
          className
        )}
        placeholder=" "
        {...inputProps}
      />
      <label
        htmlFor={inputProps.id || "floating_filled"}
        className={twMerge(
          "absolute text-sm text-gray-500 dark:text-gray-400 duration-200 peer-focus:duration-100 transform origin-[0] left-2.5",
          floatingLabel
            ? "peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-[0.72] scale-[0.72] z-10 peer-focus:text-blue-600 peer-focus:dark:text-blue-500"
            : "top-0 z-10 scale-75",
          labelStyles[height]
        )}
      >
        {label}
      </label>
    </div>
  );
}

export default InputFloatingLabel;
